module.exports = __webpack_public_path__ + "img/VVV-logo.abab2a4c.svg";